import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-four-container" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "form-fields" }
const _hoisted_4 = { class: "input-container object-container" }
const _hoisted_5 = { class: "input-container description-container" }
const _hoisted_6 = { class: "documents-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddDocuments = _resolveComponent("AddDocuments")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('intervention.stepfour.subtitle')), 1)
    ]),
    _createElementVNode("form", {
      class: "form-container",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            class: _normalizeClass(["label", _ctx.objetValue.trim() || _ctx.objetFocus ? 'active-label' : '']),
            for: "intervention-objet"
          }, _toDisplayString(_ctx.$t('app.ask.estimate.subject')), 3),
          _withDirectives(_createElementVNode("input", {
            id: "intervention-objet",
            class: "object-input",
            onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleObjetFocus(false))),
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleObjetFocus(true))),
            name: "objet",
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objetValue) = $event))
          }, null, 544), [
            [_vModelText, _ctx.objetValue]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", {
            class: _normalizeClass(["label", _ctx.descriptifValue.trim() || _ctx.descriptionFocus ? 'active-label' : '']),
            for: "descriptif"
          }, _toDisplayString(_ctx.$t('intervention.stepfour.description')), 3),
          _withDirectives(_createElementVNode("textarea", {
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleDescriptionFocus(false))),
            onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleDescriptionFocus(true))),
            class: "description-input",
            name: "descriptif",
            id: "descriptif",
            cols: "30",
            maxlength: "4000",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.descriptifValue) = $event))
          }, null, 544), [
            [_vModelText, _ctx.descriptifValue]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AddDocuments, {
          documents: _ctx.files,
          onAdd: _ctx.addFile,
          onRemove: _ctx.removeFile
        }, null, 8, ["documents", "onAdd", "onRemove"]),
        _createVNode(_component_ReglePastille, { cle: "demandeIntervention.piecesJointes" })
      ])
    ], 32)
  ]))
}